import { render, staticRenderFns } from "./TheorySignaturePdfOverwriteModal.vue?vue&type=template&id=f0ff55d6&scoped=true&"
import script from "./TheorySignaturePdfOverwriteModal.vue?vue&type=script&lang=ts&"
export * from "./TheorySignaturePdfOverwriteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ff55d6",
  null
  
)

export default component.exports